export default __webpack_public_path__ + "static/media/logo-koulutus.f3a250c9.svg";